import { FC, useCallback } from 'react';
import isHotkey from 'is-hotkey';
import { Editable } from 'slate-react';
import { setMark } from './helpers';

import { Button, Icon, Toolbar } from './components';
import Element from './Element';
import Leaf from './Leaf';

const HOTKEYS: { [key: string]: string } = {
  'mod+b': 'bold',
  'mod+s': 'size-S',
  'mod+m': 'size-M',
  'mod+l': 'size-L',
};

interface iRichTextProps {
  value: any;
  onChange: (val: any) => void;
  onLineHeightChange: (val: number) => void;
  alignment: string;
  setAlignment: (val: string) => void;
  lineHeight: number;
  formik: any;
  editor: any;
}

const alignments = [
  ['L', 'AlignLeft'],
  ['C', 'AlignCenter'],
  ['R', 'AlignRight'],
];
const RichText: FC<iRichTextProps> = ({
  value,
  onChange,
  onLineHeightChange,
  alignment,
  setAlignment,
  lineHeight,
  editor,
}) => {
  // Renderers
  const renderElement = useCallback((props) => <Element {...props} />, []);
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);

  const _handleLineHeight = (dir: number) => () => onLineHeightChange(dir);

  const _handleAlignment = (align: string) => () => setAlignment(align);

  return (
    <div className='editor-wrapper'>
      <Toolbar>
        {/* <div className='group-wrapper'>
              <MarkButton format='size' icon='S' value='S' />
              <MarkButton format='size' icon='M' value='M' isDefault />
              <MarkButton format='size' icon='L' value='L' />
            </div> */}
        <div className='group-wrapper'>
          {alignments.map(([align, icon]) => (
            <Button active={alignment === align} key={align} onMouseDown={_handleAlignment(align)}>
              <Icon>{icon}</Icon>
            </Button>
          ))}
        </div>
        <div className='group-wrapper'>
          <span className='label'>Line height</span>
          <Button disabled={lineHeight === -5 || value.length < 2} onMouseDown={_handleLineHeight(-1)}>
            <Icon>Minus</Icon>
          </Button>
          <Button disabled={lineHeight === 5 || value.length < 2} onMouseDown={_handleLineHeight(1)}>
            <Icon>Plus</Icon>
          </Button>
        </div>
      </Toolbar>
      <div className='editor-content-wrapper-container'>
        <Editable
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          placeholder='Enter sign text here...'
          onKeyDown={(event) => {
            for (const hotkey in HOTKEYS) {
              if (isHotkey(hotkey, event as any)) {
                event.preventDefault();
                const [mark, value] = HOTKEYS[hotkey].split('-');
                setMark(editor, mark, value);
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default RichText;
